<template>
	<div class="container-tabs">
		<b-tabs v-model="selectedTab" size="is-small">
			<b-tab-item label="Conta" icon="account">
				<div class="container-conta">
					<b-field grouped>
						<b-field label="Usuário" expanded>
							<b-input v-model="userData.usuario" size="is-small" disabled />
						</b-field>
						<b-field label="Email" expanded>
							<b-input v-model="userData.email" size="is-small" />
						</b-field>
					</b-field>
					<b-field label="Status">
						<b-switch v-model="userData.status" :true-value="1" :false-value="0" size="is-small">
							{{ userData.status === 1 ? 'Ativo' : 'Inativo' }}
						</b-switch>
					</b-field>
					<b-field label="Trocar Senha">
						<b-switch v-model="userData.novasenha" :true-value="0" :false-value="1" size="is-small">
							{{ !userData.novasenha ? 'Sim' : 'Não' }}
						</b-switch>
					</b-field>
					<div class="buttons">
						<b-button type="is-danger" outlined size="is-small" @click="goBack">
							Cancelar
						</b-button>
						<b-button type="is-success" outlined size="is-small" @click="edituser">
							Salvar
						</b-button>
					</div>
				</div>
			</b-tab-item>
			<b-tab-item label="Pessoas" icon="account-group">
				<div class="b-table-container">
					<div class="table-header-pessoas">
						<search width="330px" @searchtext="searchTerm = $event" />
					</div>
					<b-table
						:data="isEmpty ? [] : myData"
						size="is-small"
						:paginated="true"
						:per-page="20"
						pagination-size="is-small"
						:selected.sync="selected"
						checkable
						:focusable="false"
						:checked-rows.sync="checkedRows"
						:sticky-checkbox="true"
					>
						<template slot="empty">
							<section class="section">
								<div class="has-text-centered">
									<p>Não há nenhuma pessoa cadastrada.</p>
								</div>
							</section>
						</template>
						<b-table-column v-slot="props" field="id" label="ID" width="40" numeric>
							<h1 class="cell-custom">
								{{ props.row.id }}
							</h1>
						</b-table-column>

						<b-table-column v-slot="props" field="fantasia" label="Razão Social">
							<h1 class="cell-custom">
								{{ props.row.nomerazao }}
							</h1>
						</b-table-column>

						<b-table-column v-slot="props" field="fantasia" label="Fantasia">
							<h1 class="cell-custom">
								{{ props.row.fantasia }}
							</h1>
						</b-table-column>
						<b-table-column v-slot="props" field="status" label="Status Pessoa">
							<h1 class="cell-custom">
								{{ props.row.status == 1 ? 'Ativo' : 'Inativo' }}
							</h1>
						</b-table-column>
						<b-table-column v-slot="props" field="status-cliente" label="Status Cliente">
							<h1 class="cell-custom">
								{{ props.row.status_c == 1 ? 'Ativo' : 'Inativo' }}
							</h1>
						</b-table-column>
						<b-table-column v-slot="props" field="cpfcnpj" label="Cnpj" centered>
							<h1 class="cell-custom">
								{{ props.row.cpfcnpj }}
							</h1>
						</b-table-column>
					</b-table>
				</div>
			</b-tab-item>
		</b-tabs>
		<modal
			v-if="modalPessoa"
			title="Adicionar Pessoa"
			width="450px"
			@closemodal="$store.dispatch('setModalPessoa', false)"
		>
			<div slot="modalcontent" class="modal-container-search-box">
				<div class="img-container">
					<img class="icon-search-img" src="../../assets/icons/search.svg" alt="" />
				</div>
				<div class="search-container-modal">
					<input
						id="search"
						v-model="searchInput"
						class="searchinputimt"
						type="search"
						name="search"
						placeholder="pesquisar..."
						:class="resultSearch.length > 0 ? 'border-search' : ''"
						autocomplete="off"
					/>
					<div class="box-search-result" :class="resultSearch.length > 0 ? 'show' : 'hide'">
						<ul class="list-width">
							<li class="list-close">
								<div class="close-bg" @click="resultSearch = []">
									<feather type="x" size="15px" />
								</div>
							</li>
							<li v-for="item in resultSearch" :key="item.usuario">
								<div class="item-searchResult" @click="selectPerson(item)">
									<h1>Razão:{{ ` ` + item.nomerazao + ` ` }}</h1>
									<h2>CPF/CNPJ:{{ ` ` + item.cpfcnpj }}</h2>
								</div>
							</li>
						</ul>
					</div>
					<div class="container-box-selected-person">
						<ul class="list-items-person">
							<li v-for="person in personSelectedList" :key="person.id" class="list-item-person">
								<k-tag :data="person" @closektag="removeItem($event)" />
							</li>
						</ul>
					</div>
					<div class="buttons action-button-modal">
						<b-button type="is-danger" outlined @click="$store.dispatch('setModalPessoa', false)">
							Cancelar
						</b-button>
						<b-button
							type="is-success"
							outlined
							@click="editperson(), $store.dispatch('setModalPessoa', false)"
						>
							Salvar
						</b-button>
					</div>
				</div>
			</div>
		</modal>
	</div>
</template>

<script>
// import * as ecAxios from '../../util/ecAxios';
import search from '../../layout/components/search';
import modal from '../../layout/components/modal/modal';
import kTag from '../../layout/components/tags/k-tag';
import usuariosMixin from '../../mixins/usuarios';

export default {
	components: {
		search,
		modal,
		kTag,
	},
	mixins: [usuariosMixin],
	data() {
		return {
			selectedTab: 0,
			isTag1Active: true,
			selectedperson: [],
			resultSearch: [],
			personSelectedList: [],
			checkedRows: [],
			searchInput: '',
			selected: {},
			searchTerm: '',
			userData: {},
			isSwitchedCustom: 'Sim',
			data: [],
			isEmpty: false,
			isBordered: false,
			isStriped: false,
			isNarrowed: false,
			isHoverable: false,
			isFocusable: false,
			isLoading: false,
		};
	},
	computed: {
		modalPessoa() {
			return this.$store.getters.getModalPessoa;
		},
		database() {
			return this.$store.getters.getDatabase.selecionado;
		},
		myData() {
			const searchData = this.searchTerm;
			if (searchData) {
				return this.data.filter(
					(item) =>
						this.filterSearch(item.fantasia) ||
						this.filterSearch(item.id) ||
						this.filterSearch(item.nomerazao) ||
						this.filterSearch(item.cpfcnpj)
				);
			}
			return this.data;
		},
	},
	watch: {
		checkedRows() {
			this.$store.dispatch('setDatabase', {
				checked: this.checkedRows,
			});
		},

		database() {
			if (this.database === null) {
				this.getPessoas();
			}
		},
		selectedTab(e) {
			this.selected = {};
			this.$store.dispatch('setDatabase', {
				tabSelected: e,
			});
		},
		searchInput(e) {
			this.searchpessoas(e);
		},
		modalPessoa(e) {
			if (e) {
				this.searchInput = '';
				this.removeAllSelectedPerson();
			}
		},
		selected(e) {
			this.$nextTick(() => {
				this.checkedRows = [e];
				// this.focustTable(`a${e.id}`);
			});
			this.$store.dispatch('setDatabase', {
				selecionado: e,
				usuario: this.userData.id,
				// tabSelected: this.selectedTab,
				checked: this.checkedRows,
			});
		},
	},
	created() {
		this.getPessoas();
		this.getUser();
	},
	methods: {},
};
</script>

<style scoped>
.list-close {
	display: flex;
	width: 100%;
	align-items: center;
	margin-bottom: 5px;
	justify-content: flex-end;
}

.close-bg {
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 2px;
	border-radius: 50%;
	color: #fff;
	cursor: pointer;
	background-color: #fc7f7f;
}
.action-button-modal {
	margin-top: 20px;
}
.modal-container-search-box {
	width: 100%;
	display: flex;
	flex-direction: column;
	height: 100%;
}
.list-item-person {
	display: flex;
	width: 100%;
	margin-top: 5px;
}
.container-box-selected-person {
	display: flex;
	width: 95%;
	height: 180px;
	overflow-y: auto;
	overflow-x: auto;
	justify-content: center;
	margin-top: 10px;
}
.list-items-person {
	display: flex;
	width: 90%;
	flex-direction: column;
}

/* width */
.container-box-selected-person::-webkit-scrollbar {
	width: 7px;
}

/* Track */
.container-box-selected-person::-webkit-scrollbar-track {
	background: #f1f1f1;
}

/* Handle */
.container-box-selected-person::-webkit-scrollbar-thumb {
	background: rgb(255, 153, 0);
	border-radius: 15px;
}

/* Handle on hover */
.container-box-selected-person::-webkit-scrollbar-thumb:hover {
	background: rgb(255, 115, 0);
}
.show {
	display: flex;
}
.hide {
	display: none;
}
.tag-pessoa {
	display: flex;
	width: 100%;
	flex-wrap: wrap;
	font-size: 12px;
}

.list-width {
	width: 100%;
}
.item-searchResult {
	width: 100%;
	display: flex;
	flex-direction: column;
	cursor: pointer;
	padding: 5px;
}
.item-searchResult:hover {
	background-color: rgb(236, 232, 186);
	color: #000;
}

.item-searchResult {
	font-size: 13px;
}
.item-searchResult h2 {
	margin-top: 3px;
}
.box-search-result {
	margin-top: 35.9px;
	width: 348.5px;
	position: absolute;
	z-index: 99999;
	background: #fff;
	box-shadow: 0 4px 6px rgba(32, 33, 36, 0.28);
	/*    border-left: 1px solid #000;
    border-right: 1px solid #000;
    border-bottom: 1px solid #000; */
	transition: all 0.2s ease-in;
	padding: 10px;
}
.searchinputimt {
	all: unset;
	width: 80%;
	height: 15px;
	border-radius: 20px;
	padding: 10px;
	transition: all 0.5s ease-in;
	border: 1px solid rgb(230, 230, 230);
	box-shadow: 1px 4px 6px 0px rgba(32, 33, 36, 0.28);
}

.border-search {
	border: unset;
	box-shadow: 0 4px 6px rgba(32, 33, 36, 0.28);
	border-radius: 0px;
}
.img-container {
	display: flex;
	width: 100%;
	align-items: center;
	justify-content: center;
}
.search-container-modal {
	padding-top: 40px;
	min-height: 35px;
	display: flex;
	align-items: center;
	flex-direction: column;
}

.icon-search-img {
	width: 50%;
}
.container-tabs {
	display: flex;
	min-height: 90vh;
	background-color: #fff;
	padding: 20px;
	margin-bottom: 50px;
}
.container-conta {
	margin-top: 20px;
}
.container-table {
	margin-top: 20px;
}
.b-table-container {
	margin-top: 20px;
	padding: 10px;
}
.cell-custom {
	font-size: 12px;
}
.table-header-pessoas {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 20px;
}
</style>
